import { render, staticRenderFns } from "./ComprasMaximiliano.vue?vue&type=template&id=ac598c42&"
import script from "./ComprasMaximiliano.vue?vue&type=script&lang=js&"
export * from "./ComprasMaximiliano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports